import './style.scss'

import { mapGetters } from 'vuex'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'
import getPathFromUrl from 'util/getPathFromUrl'

export default {
  name: 'MetaNav',
  props: ['location'],
  computed: {
    ...mapGetters(['getMenu', 'loaded', 'lang', 'otherLangLink', 'getStringTranslation', 'error']),
    menu () {
      return this.getMenu(this.location)
    },
    otherLangLinkPath () {
      return this.otherLangLink ? getPathFromUrl(this.otherLangLink) : ''
    }
  },
  methods: {
    getTranslation (translationTitle) {
      return this.getStringTranslation(translationTitle)
    },
    clearSearchQuery () {
      this.$store.dispatch('clearSearchQuery')
    }
  },
  render (h) {
    const { loaded, menu, lang, otherLangLinkPath, error } = this
    return (
      <nav class='MetaNav'>
        {loaded
          ? <ul class='MetaNav__list'>
            {menu && menu.items ? (menu.items.map(i => (
              <li class='MetaNav__list-item'>
                { /* TODO: Get full path (all/them/slugs) */ }
                <router-link to={verifyLeadingSlashLang(i.object_slug, lang)} class={'MetaNav__list-item-link'}>
                  {i.title}
                </router-link>
              </li>
            ))) : null}
            <li class='MetaNav__list-item MetaNav__list-item--icon'>
              <img class='MetaNav__searchIcon' src='/imgs/searchIcon-black.svg' alt='searchIcon' />
              <router-link nativeOnClick={this.clearSearchQuery} to={lang === 'en' ? '/en/search' : '/suchen'} class={'MetaNav__list-item-link'}>
                {this.getTranslation('search')}
              </router-link>
            </li>
            {!error
            ? <li class='MetaNav__list-item'>
              <router-link to={this.lang === 'de' ? this.$route.fullPath : otherLangLinkPath} class='MetaNav__list-item-link'>
                DE
              </router-link>
            </li>
            : ''}
            {!error
            ? <li class='MetaNav__list-item'>
              <router-link to={this.lang === 'en' ? this.$route.fullPath : otherLangLinkPath} class='MetaNav__list-item-link'>
                EN
              </router-link>
            </li>
            : ''}
          </ul>
        : 'Loading…' }
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/MetaNav/index.js